import styled, { css } from "styled-components";
import { Colors, SystemColos } from "../../settings/colors";

export const InputLabel = styled.label`
    color: ${Colors.DarkText};
    margin-bottom: 10px;
`;

export const InputElement = styled.input<{ error: boolean }>`
    padding: 10px;
    border-radius: 4px;
    border: 1px solid ${Colors.Ink};
    font-size: 1rem;
    color: ${Colors.DarkText};
    align-self: stretch;
    transition: background 0.2s ease, border-color 0.2s ease;

    :hover,
    :active,
    :focus {
        background: ${Colors.LightText};
        border-color: ${Colors.DarkText};
        box-shadow: 1px 1px 4px 1px ${Colors.DarkBorder};
    }

    ${({ error }) =>
        error &&
        css`
            border: 1px solid ${SystemColos.Danger};
        `}
`;

export const InputContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    margin-bottom: 15px;
`;

export const InputError = styled.span`
    color: ${SystemColos.Danger};
    margin-top: 5px;
`;
